class LogAccessReport {
    public nbAccess: number;
    public interval: number;
    public intervalType: number;
}

export { LogAccessReport };
